module.exports = __webpack_public_path__ + "img/ozono_h.3916bdff.png";